import React from 'react';
import { Link } from 'react-router-dom';

function MasterclassEducation() {
  return (
    <section id="lena" className="education lena-section">
      <div className="lena-right">
        <h1 className="lena-name">Akvarelová masterclass pro tatéry</h1>

        <h2>O masterclass</h2>
        <p>Dvoudenní intenzivní masterclass zaměřená na práci s barvou v akvarelovém stylu. Workshop je určený pro tatéry s praxí, kteří chtějí prohloubit práci s barvou, jemné přechody, kompozici a dlouhodobou výdrž barev v kůži.</p>
        <p>Nejde o rychlokurz ani obecné školení. Jde o hlubší pochopení barvy, jejího chování v kůži a o umělecký přístup k tetování.</p>
        <p>Akvarelové tetování není jen absence kontury. Je to způsob přemýšlení o barvě, vrstvení, světle a prostoru v kůži.</p>
        <p>V této masterclass sdílím své know-how z více než 10 let praxe – zkušenosti, které nevznikly z manuálů, ale z reálné práce, zahojených tetování a dlouhodobého pozorování toho, co v kůži funguje a co ne.</p>
        <p>Workshop probíhá v malé skupině, aby byl prostor pro individuální vedení, korekce a osobní přístup.</p>

        <h2>Čím je masterclass výjimečná</h2>
        <ul>
          <li>zaměření na akvarelový přístup k barvě</li>
          <li>práce s pigmenty a jejich chováním v kůži</li>
          <li>jemné přechody bez tvrdé kontury</li>
          <li>vrstvení a hloubka barvy</li>
          <li>kompozice a flow</li>
          <li>rozdíl mezi fresh a healed prací</li>
          <li>individuální korekce během tetování</li>
        </ul>
        <p>Součástí workshopu je také tištěný workbook, který slouží jako shrnutí a opora pro další praxi.</p>

        <h2>Program</h2>
        <h3>Den 1 – teorie a rozbor</h3>
        <ul>
          <li>práce s barvou a pigmenty</li>
          <li>chování jednotlivých barev v kůži</li>
          <li>přechody bez kontury</li>
          <li>vrstvení a saturace</li>
          <li>kompozice a flow</li>
          <li>rozbor návrhů</li>
          <li>ukázka práce lektorky</li>
        </ul>

        <h3>Den 2 – praktická část</h3>
        <ul>
          <li>tetování na vlastním modelovi</li>
          <li>individuální vedení a korekce</li>
          <li>rozbor práce</li>
        </ul>
        <p><strong>Modela si zajišťuje každý účastník sám.</strong></p>

        <h2>Praktické informace</h2>
        <ul>
          <li><strong>Délka:</strong> 2 dny</li>
          <li><strong>Kapacita:</strong> max. 3 účastníci</li>
          <li><strong>Místo:</strong> studio Neon Spot, Hodonín</li>
          <li><strong>Termíny:</strong> vypisovány individuálně</li>
        </ul>

        <h2>Pro koho je masterclass určená</h2>
        <ul>
          <li>pro tatéry, kteří již samostatně tetují</li>
          <li>pro ty, kteří chtějí rozvíjet práci s barvou</li>
          <li>pro umělecky orientované tatéry</li>
        </ul>
        <p>Není vhodná pro úplné začátečníky.</p>

        <h2>Cena a přihlášení</h2>
        <p>Cena masterclass je <strong>19 000 Kč</strong>.</p>
        <p>Rezervace místa je potvrzena po uhrazení nevratné zálohy <strong>9 000 Kč</strong>. Doplatek je splatný nejpozději 14 dní před konáním workshopu.</p>
        <p>Pro přihlášení nebo více informací mě prosím kontaktujte individuálně.</p>

        <button className="button-booking" type="button">
          <Link to="/contact/#form">Objednat se</Link>
        </button>
      </div>
    </section>
  );
}

function AccreditedCoursesEducation() {
  return (
    <section id="lena" className="education lena-section">
      <div className="lena-right">
        <h1 className="lena-name">Akreditované kurzy</h1>
        <p>Připravuji certifikované kurzy pro začínající tatéry ve spolupráci s akreditovanou akademií. Více informací brzy.</p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
      </div>
    </section>
  );
}

function EducationPage({ type }) {
  if (type === 'masterclass') {
    return <MasterclassEducation />;
  }

  return <AccreditedCoursesEducation />;
}

export default EducationPage;
